import React from "react";
import { connect } from 'react-redux';
import axios from 'axios'
import _ from 'lodash';

import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import { geocodeByAddress, getLatLng} from 'react-places-autocomplete';

import SettingsForm from './SettingsForm';
import {getUpdateUserDataRequest, getUpdateUserDataSuccess} from '../../actions/session';
import {setErrorMessage, resetErrors} from '../../actions';
import { getCameras } from '../../actions/cameraRequirementActions';
import {fetchInfo} from '../../actions';
import { getHeader } from "../../helper";
import CreateMethod from "./CreateMethod";

class Settings extends React.Component {
    constructor(props) {
        super(props);

        const {session:{currentUser}} = props;

        this.state = {
            formEdit: false,
            checkChanged: false,
            autocompleteCamera: {},
            toolAutoCompleteData: [],
            order_method_autocompete: {},

            createMethodParams: {
                show: false,
                type: 'default',
            },
        }
    }

    componentWillMount() {
        this.setCurrentData();
    }

    componentDidMount() {
        const {
            default_order_camera_requirement
        } = this.state;

        this.props.getCameras(
            {id: default_order_camera_requirement},
            (camera) => {
                let results = [];
                if(camera.results && camera.results.length) {
                    results = [
                        ...camera.results
                    ]
                }
                else if(camera && camera.id) {
                    results.push(camera)
                }
                else return false;
                
                this.setState({
                    camera_requirementValue: default_order_camera_requirement ? results[0].title : '',
                    autocompleteCamera: Object.assign(
                        this.state.autocompleteCamera,
                        {..._.mapKeys(camera.results, 'id')}
                    )
                });
            }
        );
    
        this.getOrderObjects((objects) => {
            if(!objects.results.length) return false;
            
            const {
                default_order_object_type,
                default_order_order_method,
                default_order_order_method_value
            } = this.state;
            let obj_type = default_order_object_type;
            
            if(!obj_type) {
                let typeObject = objects.results.filter(object => object.id === 2);
                obj_type = typeObject.length ? typeObject[0].id : objects.results[0].id;
            }
           
            this.setState({
                default_order_object_type: obj_type
            });

            this.getMethodTypes(
                obj_type,
                (methodTypes) => {
                    if(!methodTypes.results.length) return false;
                    let currentMethodType = methodTypes.results[0];
                   
                    let paramsForMethods = {
                        q: default_order_order_method_value,
                        method_type: currentMethodType.id,
                        order_type: 0,
                    };

                    if(default_order_order_method && default_order_order_method !== "") {
                        paramsForMethods = {id: default_order_order_method};
                    }
                   
                    this.getShootingMethods(
                        paramsForMethods,
                        (methods) => {
                            
                            if(!methods.results.length) return false;
                            let currentMethod = methods.results[0];
                            
                            this.setState({
                                default_order_order_method: currentMethod.id,
                                default_order_order_method_value: currentMethod.title || '',
                                default_order_order_method_type: currentMethod.method_type_id,
                                default_order_order_method_measure: currentMethod.measure && currentMethod.measure.id || '',
                                default_order_order_method_measure_value: currentMethod.measure && currentMethod.measure.title || '',
                                default_order_order_method_description: currentMethod.content || '',

                                createMethodButtonShow: currentMethod.is_approve ? false : true,
                                createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                            })
                        }
                    )

                }
            )
        });
    }

    handleObject(object_type) {
        const {data} = this.props;
        const {
            default_order_order_method,
            default_order_order_method_value
        } = this.state;
        
        this.setState({
            default_order_object_type: object_type,
            checkChanged: true,
        });

        let currentObjectType = data['order_object_type'].results.filter(item => item.id === parseInt(object_type));

         this.getMethodTypes(
            object_type,
            (methodTypes) => {
                if(!methodTypes.results.length) return false;

                let methodDataType = methodTypes.results.filter(item => item.id === currentObjectType[0].default_method_type_id);
                let currentMethodType = methodDataType.length ? methodDataType[0] : methodTypes.results[0];

                this.setState({
                    default_order_order_method_type: currentMethodType.id
                });
            
                let paramsForMethods = {
                    method_type: currentMethodType.id,
                    order_type: 0,
                };
                
                this.getShootingMethods(
                    paramsForMethods,
                    (methods) => {
                        if(!methods.results.length) return false;
                        let currentMethod = methods.results[0];
                    
                        this.setState({
                            default_order_order_method: currentMethod.id,
                            default_order_order_method_value: currentMethod.title || '',           
                            default_order_order_method_measure: currentMethod.measure && currentMethod.measure.id || '',
                            default_order_order_method_measure_value: currentMethod.measure && currentMethod.measure.title || '',
                            default_order_order_method_description: currentMethod.content || '',

                            createMethodButtonShow: currentMethod.is_approve ? false : true,
                            createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                        })
                    }
                )
            }
         )
    }

    handleChangeAddressText(address) {
        if (!address.trim()) {
            this.setState({
                    default_order_address_text: "",
                    default_order_address_latitude: 0, //null
                    default_order_address_longitude: 0, //null
            })
            return;
        }

        this.setState({
            default_order_address_latitude: 0,
            default_order_address_longitude: 0,
            default_order_address_text: address,
            checkChanged: true,
        });
    }

    getGeoCodeByAddress(address) {
        geocodeByAddress(address)
        .then(results => {
            return getLatLng(results[0])
        })
        .then(latLng =>
            this.handleChangeAddress(address, latLng)
        )
        .catch(error => console.error('Error', error))
    }

    handleChangeAddress(address, pos) {
        this.setState({
            default_order_address_text: address,
            default_order_address_latitude: pos.lat,
            default_order_address_longitude: pos.lng
        });
    }

    handleCameraFocus(value) {
        if(this.state.autocompleteCamera.length) return false;

        this.props.getCameras(
            {q: value},
            (data) => {
                
                this.setState({
                    camera_requirementValue: value,
                    autocompleteCamera: Object.assign(
                        this.state.autocompleteCamera,
                        {..._.mapKeys(data.results, 'id')}
                    ),
                });
        });
    }

    handleCamera(value) {
        if(value.trim() === this.state.camera_requirementValue)
            return false;

        this.setState({
            camera_requirementValue: value,
            checkChanged: true,
        });
        
        this.props.getCameras(
            {q: value},
            (data) => {
                
                this.setState({
                    autocompleteCamera: Object.assign(
                        this.state.autocompleteCamera,
                        {..._.mapKeys(data.results, 'id')}
                    ),
                });
        });
    }

    handleCameraSelect(item) {
        if(!item || !item.id) return;

        this.setState({
            default_order_camera_requirement: item.id,
            camera_requirementValue: item.title,
            checkChanged: true,
        });
    }

    getOrderObjects(afterSuccess) {
        const {fetchInfo} = this.props;

        fetchInfo([
            {
                query: 'order_object_type',
                params: {
                    order_type: 0
                },
                afterSuccess: (data) => {
                    if(afterSuccess){
                        afterSuccess(data)
                    }
                }
            },
        ]);
    }

    getMethodTypes(object_type_id, afterSuccess) {
        const {fetchInfo} = this.props;

        fetchInfo([
            {
                query: 'order_method_type',
                params: {
                 //   object_type_id: object_type_id
                },
                afterSuccess: (data) => {
                    if(afterSuccess){
                        afterSuccess(data)
                    }
                }
            }
        ])
    }

    getShootingMethods(params, callback) {

        axios.get(`${window.siteUrl}/api/v1/order_method/`, {
            params,
            headers: getHeader()
        })
        .then(response => {
            if(callback) {
                callback(response.data)
            }

            this.setState({
                order_method_autocompete: Object.assign({},
                    this.state.order_method_autocompete,
                    {..._.mapKeys(response.data.results, 'id')}
                )
            });
        })
        .catch(error => {
            console.error(" error", error.response.data);
        });
    }

    setCurrentData() {
        const {currentUser} = this.props.session;

        this.setState({
            default_order_address_text: currentUser.default_order_address_text || '',
            default_order_address_latitude: currentUser.default_order_address_latitude || 0,
            default_order_address_longitude: currentUser.default_order_address_longitude || 0,

            default_order_over_days: currentUser.default_order_over_days || 0,
            default_order_order_time_at: currentUser.default_order_order_time_at || '10:00',
            default_order_order_time_end_at: currentUser.default_order_order_time_end_at || '20:00',

            default_order_object_type: currentUser.default_order_object_type_id,
            default_order_order_method_type: '',//create new method
            default_order_order_method: currentUser.default_order_order_method_id || null,
            default_order_order_method_value: '',//create new method
            default_order_order_method_description: '',//create new method
            default_order_order_method_measure: '',//create new method
            default_order_order_method_measure_value: '',//create new method

            createMethodButtonShow: false,
            createMethodStatus: 'create',

            comment: currentUser.default_order_position_content || '',
            default_order_address_comment: currentUser.default_order_address_comment || '',

            default_order_camera_requirement: currentUser.default_order_camera_requirement || '',
            camera_requirementValue: '',
            default_order_contractor_minimal_rating: currentUser.default_order_contractor_minimal_rating || 0,
            default_order_allow_upload_max_radius: currentUser.default_order_allow_upload_max_radius || '',
            default_order_contractor_count: currentUser.default_order_contractor_count || 0,
            default_order_is_auction: currentUser.default_order_is_auction || false,
            default_order_auction_step: currentUser.default_order_auction_step || 90,
            default_order_auction_time: currentUser.default_order_auction_time || 1440,
            default_order_auction_set_contractor: currentUser.default_order_auction_set_contractor || 90,
            default_order_allow_upload_results_from_web: currentUser.default_order_allow_upload_results_from_web || false,
            default_order_increase_price: currentUser.default_order_increase_price || '',
            default_order_decrease_price: currentUser.default_order_decrease_price || '',

            is_orders_always_public: currentUser.is_orders_always_public,
            step_auction: currentUser.step_auction,
        });
    }

    onEdit(save = false) {
        if(this.state.formEdit && save === false)
            this.setCurrentData();

        this.setState({
            formEdit: !this.state.formEdit,
            checkChanged: false,
        });
    }

    handleOnChange(value, field) {
      console.warn(`${field}: ${value}`)
    
        if(field === "default_order_contractor_count") {
            if(!value || !parseInt(value)) value = 1;
        }

        this.setState({
            [field]: value,
            checkChanged: true
        })
    }

    handleMethodSelect(item) {
        this.setState({
            default_order_order_method_value: item.title || '',
            default_order_order_method: item.id,
            default_order_order_method_measure: item.measure && item.measure.id || '',
            checkChanged: true,

            default_order_order_method_description: item.is_standard ? 'Без описания' : item.content || '',
            default_order_order_method_measure_value: item.is_standard ? 'Без дополнительного инструмента' : item.measure && item.measure.title || '',

            createMethodButtonShow: item.is_approve ? false : true,
            createMethodStatus: item.is_approve ? 'create' : 'edit',
        })
    }

    handleMethodType(value) {
        this.setState({
            default_order_order_method_type: value,
            checkChanged: true
        })

            
        let paramsForMethods = {
            method_type: value,
            order_type: 0,
        };
            
        this.getShootingMethods(
            paramsForMethods,
            (methods) => {
                if(!methods.results.length) return false;
                let currentMethod = methods.results[0];
            
                this.setState({
                    default_order_order_method: currentMethod.id,
                    default_order_order_method_value: currentMethod.title || '',           
                    default_order_order_method_measure: currentMethod.measure && currentMethod.measure.id || '',
                    // default_order_order_method_measure_value: currentMethod.measure && currentMethod.measure.title || '',
                    // default_order_order_method_description: currentMethod.content || '',

                    default_order_order_method_description: currentMethod.is_standard ? 'Без описания' : currentMethod.content || '',
                    default_order_order_method_measure_value: currentMethod.is_standard ? 'Без дополнительного инструмента' : currentMethod.measure && currentMethod.measure.title || '',

                    createMethodButtonShow: currentMethod.is_approve ? false : true,
                    createMethodStatus: currentMethod.is_approve ? 'create' : 'edit',
                })
            }
        )
    }

    handleMethod(value) {
        const {
            default_order_order_method_type,
        } = this.state;

        this.setState({
            default_order_order_method_value: value,
        });

        this.getMethodValues(
            value,
            default_order_order_method_type,
            (data) => this.setMethodValues(value, data)
        );
    }

    getMethodValues(value, method_type, afterSuccess) {
        if(!method_type) return false;
        
        axios.get(`${window.siteUrl}/api/v1/order_method/`, {
            params: {
                q: value,
                method_type: method_type,
               // order_type: this.state.isStandard ? 0 : 1,
            },
            headers: getHeader()
        })
        .then(response => {
            if(afterSuccess) afterSuccess(response.data)
            return;
        })
        .catch(error => {
            console.error("error", error);
        });
    }

    setMethodValues(value, response) {

        let length = value.trim().length;
        let checkingRes = [];

        if(length)
        {
            checkingRes = response.results.filter(item =>
                (item.title).toLowerCase() == value.trim().toLowerCase()
            );
        }

        this.setState({
            order_method_autocompete: Object.assign({},
                this.state.order_method_autocompete,
                {..._.mapKeys(response.results, 'id')}
            ),

            createMethodButtonShow: checkingRes.length ? checkingRes[0].is_approve ? false : true : true,

            default_order_order_method_description: checkingRes.length ? checkingRes[0].content : this.state.default_order_order_method_description,
            default_order_order_method_measure: checkingRes.length ? checkingRes[0].measure && checkingRes[0].measure.id : this.state.default_order_order_method_measure,
            default_order_order_method_measure_value: checkingRes.length ? checkingRes[0].measure && checkingRes[0].measure.title : this.state.default_order_order_method_measure_value,

            default_order_order_method: checkingRes.length ? checkingRes[0].id : this.state.default_order_order_method,
            checkChanged: true
        });
    }

    onSubmit(e){
        e.preventDefault();

        if(!this.state.checkChanged) {
            Alert.error('Изменений нет', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });

            this.onEdit(true)
            this.props.resetErrors()
            return;
        }
        
        const { currentUser, token } = this.props.session;
        const { default_order_increase_price, default_order_decrease_price } = this.state;
        let increase = parseFloat(default_order_increase_price.toString().replace(',', '.'));
        let decrease = parseFloat(default_order_decrease_price.toString().replace(',', '.'));

        if(!increase || increase === NaN) increase = 0;
        if(!decrease || decrease === NaN) decrease = 0;

        const payload = {
            is_orders_always_public: this.state.is_orders_always_public,
            step_auction: this.state.step_auction,
            default_order_address_comment: this.state.default_order_address_comment || '',

            default_order_over_days: this.state.default_order_over_days,
            default_order_order_time_at: this.state.default_order_order_time_at || '',
            default_order_order_time_end_at: this.state.default_order_order_time_end_at || '',
            default_order_address_text: this.state.default_order_address_text || '',
            default_order_address_latitude: this.state.default_order_address_latitude || 0,
            default_order_address_longitude: this.state.default_order_address_longitude || 0,
            default_order_camera_requirement: this.state.default_order_camera_requirement || 0,
            default_order_contractor_minimal_rating: this.state.default_order_contractor_minimal_rating || 0,
            default_order_allow_upload_max_radius: this.state.default_order_allow_upload_max_radius,
            default_order_contractor_count: this.state.default_order_contractor_count || 0,
            default_order_is_auction: this.state.default_order_is_auction || false,
            default_order_auction_step: this.state.default_order_auction_step || 90,
            default_order_auction_time: this.state.default_order_auction_time || 1440,
            default_order_allow_upload_results_from_web: this.state.default_order_allow_upload_results_from_web || false,
            default_order_auction_set_contractor: this.state.default_order_auction_set_contractor || 90,
            default_order_increase_price: increase,
            default_order_decrease_price: decrease,
            default_order_object_type: parseInt(this.state.default_order_object_type, 10),
            default_order_order_method: this.state.default_order_order_method,
            default_order_order_method_type: this.state.default_order_order_method_type,
            default_order_order_method_description: this.state.default_order_order_method_description || '',
            default_order_order_method_measure: this.state.default_order_order_method_measure || '',
            default_order_position_content: this.state.comment || '',
        }

        axios.patch(
            `${window.siteUrl}/api/v1/user/${currentUser.id}/`,
            payload,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                checkChanged: false
            }, () => {
                Alert.success('Изменения сохранены', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            });

            this.props.getUpdateUserDataRequest();

            setTimeout(() => {
                this.props.getUpdateUserDataSuccess(response.data)
            }, 100)
            
            this.onEdit(true)
            this.props.resetErrors()
            
        }) 
        .catch(error=> {
            this.props.setErrorMessage(error.response.data)
        });
    }

    openNewMethod() {
        this.setState({
            createMethodParams: {
                show: true,
                type: 'default',
            },
        })
    }

    closeNewMethod() {
        this.setState({
            createMethodParams: {
                show: false,
                type: 'default',
            },
        })
    }

    saveNewMethod() {
        const {
            default_order_order_method
        } = this.state;

        let currentMethod = this.state.order_method_autocompete[default_order_order_method]

        this.setState({
            checkChanged: true,
            createMethodButtonShow: currentMethod && currentMethod.is_approve ? false : true,
            createMethodStatus: currentMethod && currentMethod.is_approve ? 'create' : 'edit',
        }, () => this.closeNewMethod())
    }

    resetNewMethodData() {
        const {
            default_order_order_method_measure,
            default_order_order_method_measure_value,
            default_order_order_method_description,
            createMethodStatus,
        } = this.state;

        this.setState({
            default_order_order_method_measure: createMethodStatus === 'create' ? '' : default_order_order_method_measure,
            default_order_order_method_measure_value: createMethodStatus === 'create' ? '' : default_order_order_method_measure_value,
            default_order_order_method_description: createMethodStatus === 'create' ? '' : default_order_order_method_description,

            checkChanged: true,
        }, () => this.closeNewMethod())
    }

    handleNewMethodTool(value) {
        let valueLength = value.trim().length;

        this.setState({
            default_order_order_method_measure_value: value,
            checkChanged: true
        });

        axios.get(`${window.siteUrl}/api/v1/measure/`, {
            params: {
                q: value,
            },
            headers: getHeader()
        })
        .then(response => {
            this.setState({
                toolAutoCompleteData: response.data.results,
                checkChanged: true
            })
        })
        .catch(error => {
            console.error(" error", error.response.data);
        });
    }

    handleNewMethodToolSelect(value) {
        this.setState({
            default_order_order_method_measure: value.id,
            default_order_order_method_measure_value: value.title,
            checkChanged: true
        });
    }

    render(){
        const { errorMessages } = this.props

        return(
                [<CreateMethod
                    key="t1"
                    inputProps={this.state}
                    toolAutoCompleteData={this.state.toolAutoCompleteData}
                    handleDescription={(value, field) => this.handleOnChange(value, field)}
                    handleTool={(value) => this.handleNewMethodTool(value)}
                    handleToolSelect={(value) => this.handleNewMethodToolSelect(value)}
                    handleMethod={(value) => this.handleMethod(value)}
                    handleMethodSelect={(item) => this.handleMethodSelect(item)}
                    closeNewMethod={() => this.closeNewMethod()}
                    saveNewMethod={() => this.saveNewMethod()}
                    resetNewMethodData={() => this.resetNewMethodData()}
                    order_method_autocompete={this.state.order_method_autocompete}
                />,
                <div key="t2" className="right-content native-scroll right-content-bottom right-content-width">
                                
                    <div className="screen-outer-block-wrap native-scroll menu-content">
                        <div className="menu-content-settings menu-content-item tab-parent screen-center-block">

                            <Alert stack={{limit: 1}} />

                            <div className="rounded-white-block">
                                <SettingsForm
                                    {...this.state}
                                    errorMessages={errorMessages}
                                    handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                    onSubmit={(e) => this.onSubmit(e)}
                                    onEdit={() => this.onEdit()}
                                    handleObject={(value) => this.handleObject(value)}
                                    handleCamera={(value) => this.handleCamera(value)}
                                    handleCameraSelect={(item) => this.handleCameraSelect(item)}
                                    handleCameraFocus={(value) => this.handleCameraFocus(value)}
                                    handleChangeAddressText={(address) => this.handleChangeAddressText(address)}
                                    getGeoCodeByAddress={(e) => this.getGeoCodeByAddress(e)}
                                    handleMethodType={(value) => this.handleMethodType(value)}
                                    handleMethod={(value) => this.handleMethod(value)}
                                    handleMethodSelect={(item) => this.handleMethodSelect(item)}
                                    order_method_autocompete={this.state.order_method_autocompete}
                                    openNewMethodModal={() => this.openNewMethod()}
                                    />
                            </div>
                        </div>
                    </div>
                </div>]
        )
    }
}

export default connect(
    state => ({
        ...state
    }),
    {
        getUpdateUserDataRequest,
        getUpdateUserDataSuccess,
        setErrorMessage,
        resetErrors,
        fetchInfo,
        getCameras,
    }
)(Settings);


// WEBPACK FOOTER //
// ./src/components/Account/Settings.js